import { render, staticRenderFns } from "./textLeft.vue?vue&type=template&id=f015bc3a&scoped=true&"
import script from "./textLeft.vue?vue&type=script&lang=js&"
export * from "./textLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f015bc3a",
  null
  
)

export default component.exports